<template>
  <div class="invite-wrap">
    <div class="mobile-screen" v-if="platform == 'mobile'">
      <div class="main">
        <div class="header">
          <img src="../../static/img/h5logo.png" alt="logo" />
        </div>

        <div class="section">
          <div class="title">
            <span v-if="!inviteInfo.mobile_phone">&nbsp;</span>
            <span v-if="inviteInfo.mobile_phone"
              >好友 {{ inviteInfo.mobile_phone }} 送您优惠办签证</span
            >
          </div>

          <div class="price">
            <div class="price-content">
              <span class="money" v-if="sysConfigCoupon">
                <span class="price-signo">￥</span
                ><span class="num">{{
                  sysConfigCoupon.cash_reduce / 100
                }}</span>
              </span>
            </div>
          </div>

          <p class="info" v-if="sysConfigCoupon">
            请输入手机号并完成注册，立即获得 ￥{{
              sysConfigCoupon.cash_reduce / 100
            }}
            优惠券！
          </p>

          <div class="input-area">
            <div
              class="input-group"
              @click="focusPhone()"
              :class="{
                'focused-box': phoneFocused,
                'unfocus-box': !phoneFocused,
                error: haveError,
              }"
            >
              <div class="country">+86</div>
              <input
                type="tel"
                id="phone"
                maxlength="11"
                autocomplete="off"
                v-model.trim="phoneNumber"
                @keyup="validatePhone()"
                @change="validatePhone()"
                ref="phone"
                @focus="phoneFocused = true"
                @blur="phoneFocused = false"
              />
            </div>
          </div>

          <div class="btn-area">
            <button class="btn" @click="beforeCheck()" :disabled="submitting">
              立即注册领取优惠
            </button>
          </div>
        </div>
      </div>

      <div class="footer">
        粤ICP备15048723号-2<br />
        Copyright© 熊猫签证 2016-2017，版权所有
      </div>

      <div
        class="fixed-footer"
        v-show="showBar"
        :class="{
          'focused-footer': phoneFocused,
          'unfocus-footer': !phoneFocused,
        }"
        @click="goShop"
      >
        <img src="../../static/img/download-left.png" class="left" />
        <img src="../../static/img/download-right.png" class="right" />
        <div class="close-area" @click="closeBar"></div>
      </div>
    </div>

    <div class="pc-screen" v-if="platform == 'pc'">
      <div class="main">
        <div class="header"></div>

        <div class="section">
          <div class="title">
            <span v-if="!inviteInfo.mobile_phone">&nbsp;</span>
            <span v-if="inviteInfo.mobile_phone"
              >好友 {{ inviteInfo.mobile_phone }} 送您优惠办签证</span
            >
          </div>

          <div class="price">
            <div class="price-content">
              <span class="money" v-if="sysConfigCoupon">
                <span class="price-signo">￥</span
                ><span class="num">{{
                  sysConfigCoupon.cash_reduce / 100
                }}</span>
              </span>
            </div>
          </div>

          <p class="info" v-if="sysConfigCoupon">
            请输入手机号并完成注册，立即获得 ￥{{
              sysConfigCoupon.cash_reduce / 100
            }}
            优惠券！
          </p>

          <div class="input-area">
            <div
              class="input-group"
              @click="focusPhone()"
              :class="{
                'focused-box': phoneFocused,
                'unfocus-box': !phoneFocused,
                error: haveError,
              }"
            >
              <div class="country">+86</div>
              <input
                type="tel"
                id="phone"
                maxlength="11"
                autocomplete="off"
                v-model.trim="phoneNumber"
                @keyup="validatePhone()"
                @change="validatePhone()"
                ref="phone"
                @focus="phoneFocused = true"
                @blur="phoneFocused = false"
              />
            </div>
          </div>

          <div class="btn-area">
            <button class="btn" @click="beforeCheck()" :disabled="submitting">
              立即注册领取优惠
            </button>
          </div>
        </div>
      </div>

      <div class="footer">
        粤ICP备15048723号-2 Copyright© 熊猫签证 2016-2017，版权所有
      </div>
    </div>
  </div>
</template>

<script>
import '../lib/url.js';
import utils from '../services/tools.js';
import InviteService from '../services/inviteService.js';
import systemService from '../services/systemService';
import toast from '../services/toast.js';

export default {
  name: 'invite',
  data() {
    return {
      platform: utils.getPlatform(),
      mobile_phone: -1, // 用户编号
      inviteInfo: {}, // 邀请信息
      phoneNumber: '',
      onFirstPage: true, // 第一页
      phoneFocused: false, // 输入框是否聚焦
      haveError: false,
      inviteService: new InviteService(this.$http),
      submitting: false,
      showBar: true,
      sysConfigCoupon: null,
    };
  },
  methods: {
    /**
     * 获取用户编号
     */
    getUID() {
      utils.init();
      if (!this.$route.query.mobile_phone) {
        toast.show('缺少参数');
        return;
      }
      this.mobile_phone = parseInt(this.$route.query.mobile_phone);
    },

    goShop() {
      window.location.href =
        'http://api.11visa.com/oss/open/channel_stat?channel=rrqah2w2';
    },

    closeBar(e) {
      debugger;
      e.stopPropagation();
      this.showBar = false;
    },

    /**
     * 主动去给输入框聚焦
     */
    focusPhone() {
      this.$refs.phone.focus();
    },

    /**
     * 验证手机号
     */
    validatePhone() {
      this.haveError = !this.isPhoneValid();
    },

    /**
     * 手机号是否合法
     */
    isPhoneValid() {
      this.phoneNumber = this.phoneNumber.replace(/\D/g, '');

      return /^1\d{10}$/.test(this.phoneNumber);
    },

    /**
     * 表单校验
     */
    beforeCheck() {
      let err = '';

      this.validatePhone();

      if (!this.phoneNumber) {
        err = '请输入手机号';
      } else if (!this.isPhoneValid()) {
        err = '手机号格式不正确';
      }

      if (err) {
        return toast.show(err, 2000);
      }

      this.submitting = true;

      this.inviteCheck();
    },

    /**
     * 检测是否注册、新用户
     */
    inviteCheck() {
      const inviterMobilePhone = `${this.mobile_phone}`;
      this.inviteService
        .inviteCheck(inviterMobilePhone, this.phoneNumber)
        .then((data) => {
          const result = data.body;

          if (result.ret === 0) {
            setTimeout(() => {
              this.$router.push({
                name: 'register',
                params: {
                  userId: this.inviteInfo.user_account_id,
                  mobilePhone: this.phoneNumber,
                  cash_reduce: this.sysConfigCoupon.cash_reduce,
                },
              });
            }, 50);
          } else {
            toast.show(result.msg, 3000);
            this.submitting = false;
            if (result.ret < -1) {
              setTimeout(() => {
                this.goDownload();
              }, 1500);
            }
          }
        })
        .catch(() => {
          this.submitting = false;
          toast.show('领取失败!');
        });
    },

    /**
     * 去下载页面
     */
    goDownload() {
      utils.goDownload();
    },

    /**
     * 获取邀请信息
     */
    getInviteInfo() {
      this.inviteService
        .queryUserInviteInfo(this.mobile_phone)
        .then((data) => {
          const result = data.body;
          if (result.ret === 0) {
            this.inviteInfo = result.body;
            this.inviteInfo.mobile_phone = InviteService.getHideMobilePhone(
              this.mobile_phone,
            );
          } else {
            toast.show(result.msg);
          }
        })
        .catch((error) => toast.show(error));
    },
    /**
     * 获取系统配置
     */
    sysConfigGet() {
      systemService.sysConfigGet().then((data) => {
        this.sysConfigCoupon = data.coupon;
        utils.setTitle(
          `好友送你￥${this.sysConfigCoupon.cash_reduce / 100}新人礼包`,
        );
      });
    },
  },
  mounted() {
    this.getUID();
    this.getInviteInfo();
    this.sysConfigGet();
  },
  created() {
    // 设置浏览器title
    utils.setTitle('熊猫签证送你新人大礼');
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  line-height: 1;
}

img {
  max-width: 100%;
}

.invite-wrap {
  height: 100%;
  background-color: white;
  letter-spacing: 0.0015rem;
}

.mobile-screen {
  padding-bottom: 1.04rem;
  background-color: white;
  .main {
    min-height: 100%;
    margin-bottom: -1rem;
    background-color: white;
    &:after {
      content: '';
      display: block;
      height: 1rem;
    }
  }

  .header {
    background: url(../../static/img/header-invite.png) no-repeat center bottom;
    background-size: cover;
    position: relative;
    height: 1.48rem;
    padding-top: 0.45rem;

    img {
      margin: 0 auto;
      width: 1.45rem;
      display: block;
    }
  }

  .footer {
    height: 0.45rem;
    font-size: 0.12rem;
    text-align: center;
    line-height: 1.3;
    color: #cfcfcf;
    margin-top: 0.55rem;
  }

  .fixed-footer {
    padding: 0 0.11rem 0 0.18rem;
    height: 0.64rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(60, 60, 60, 0.8);
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: block;
    margin-top: 0.1rem;
    cursor: pointer;
    .left {
      width: 1.335rem;
      margin-top: 0.11rem;
    }

    .right {
      float: right;
      width: 1.605rem;
      margin-top: 0.16rem;
    }
    .close-area {
      position: absolute;
      width: 0.15rem;
      height: 0.15rem;
      right: 0.08rem;
      top: 0.25rem;
    }
  }

  .invite-code {
    text-align: center;

    .h-line {
      border: none;
      border-bottom: 1px dashed #e3e3e3;
      margin-top: 0.28rem;
    }

    .code {
      color: #333;
      font-size: 0.3rem;
      margin: 0.28rem auto 0.15rem auto;
      width: 1.4rem;
      padding-bottom: 0.1rem;
      border-bottom: 2px solid #333;
    }
  }

  .section {
    padding: 0 0.2rem;
  }

  .title {
    text-align: center;
    margin-top: 0.36rem;
  }

  .price {
    padding: 0.22rem 0 0.18rem 0;
    background: url(/static/img/coupon-bg.png) no-repeat center center;
    background-size: contain;
    width: 3.2rem;
    margin: 0 auto;

    .price-content {
      width: 1.67rem;
      height: 0.805rem;
      text-align: center;
      background: url(../../static/img/price.png) no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      font-size: 0.24rem;
      color: #ff5a60;
      padding-right: 0.12rem;

      .money {
        line-height: 0.805rem;
        font-size: 0.36rem;
        font-weight: 600;

        .price-signo {
          font-size: 0.14rem;
          position: relative;
          top: -0.15rem;
        }

        .num {
          font-size: 0.36rem;
        }
      }
    }
  }

  .info {
    color: #909090;
    font-size: 0.14rem;
    text-align: center;
    margin-top: 0.08rem;

    &:first-of-type {
      margin-top: 0.15rem;
    }
  }

  .input-area {
    margin-top: 0.26rem;

    .input-group {
      border: 1px solid #e3e3e3;
      border-radius: 0.04rem;
      height: 0.44rem;
      padding: 0 0.15rem;
      font-size: 0;
      display: -webkit-box;
      display: flex;
      -webkit-box-align: center;
      align-items: center;

      &.error {
        border-color: #f44336 !important;
      }
    }

    .country {
      color: #aaa;
      font-size: 0.16rem;
    }

    input {
      -webkit-box-flex: 1;
      flex: 1;
      font-size: 0.17rem;
      border: none;
      outline: none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      display: inline;
      background: transparent;
      padding-left: 0.09rem;
    }

    .input-help {
      margin: 0.1rem auto 0 auto;
      font-size: 0.15rem;
      color: #f44336;
      display: none;
    }
  }

  .btn-area {
    margin-top: 0.15rem;

    .btn {
      font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
        FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
        Hiragino Sans GB W3, FontAwesome, sans-serif;
      display: block;
      width: 100%;
      background-color: #ff5a60;
      border: none;
      outline: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-appearance: none;
      height: 0.44rem;
      line-height: 0.44rem;
      text-align: center;
      font-size: 0.16rem;
      color: white;
      border-radius: 0.04rem;

      &:disabled {
        background-color: rgba(255, 90, 96, 0.76);
      }
    }
  }
}

.pc-screen {
  background-color: #f3f4f6;
  min-height: 100%;
  padding-top: 132px;
  position: relative;
  padding-bottom: 80px;

  .main {
    width: 640px;
    margin: 0 auto;
    border-radius: 4px;
    background-color: white;
    overflow: hidden;
    padding-bottom: 50px;
  }

  .header {
    background: @red url(../../static/img/invite/banner-pc.jpg) no-repeat center
      bottom;
    background-size: contain;
    position: relative;
    height: 140px;
  }

  .footer {
    font-size: 0.12rem;
    text-align: center;
    color: #aaa;
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
  }

  .section {
    padding: 0 0.2rem;
  }

  .title {
    text-align: center;
    margin-top: 36px;
    font-size: 18px;
    color: #333;
  }

  .price {
    background: url(../../static/img/invite/coupon-web.png) no-repeat center
      center;
    background-size: contain;
    width: 460px;
    height: 150px;
    margin: 23px auto 0 auto;

    .price-content {
      text-align: center;
      margin: 0 auto;
      color: #ff5a60;
      padding-right: 12px;
      line-height: 170px;

      .money {
        font-weight: 600;

        .price-signo {
          font-size: 32px;
        }

        .num {
          font-size: 0.64rem;
        }
      }
    }
  }

  .info {
    color: #6f6f6f;
    font-size: 16px;
    text-align: center;
    margin-top: 44px;
  }

  .input-area {
    margin-top: 30px;

    .input-group {
      border: 1px solid #e3e3e3;
      border-radius: 0.04rem;
      height: 48px;
      padding: 0 0.15rem;
      font-size: 0;
      display: -webkit-box;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      width: 360px;
      margin: 0 auto;

      &.error {
        border-color: #f44336 !important;
      }
    }

    .country {
      color: #aaa;
      font-size: 0.16rem;
    }

    input {
      -webkit-box-flex: 1;
      flex: 1;
      font-size: 0.17rem;
      border: none;
      outline: none;
      -webkit-appearance: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      display: inline;
      background: transparent;
      padding-left: 0.09rem;
    }

    .input-help {
      margin: 0.1rem auto 0 auto;
      font-size: 0.15rem;
      color: #f44336;
      display: none;
    }
  }

  .btn-area {
    margin-top: 30px;

    .btn {
      font-family: Segoe UI, Lucida Grande, Helvetica, Arial, Microsoft YaHei,
        FreeSans, Arimo, Droid Sans, wenquanyi micro hei, Hiragino Sans GB,
        Hiragino Sans GB W3, FontAwesome, sans-serif;
      display: block;
      width: 360px;
      margin: 0 auto;
      background-color: #ff5a60;
      border: none;
      outline: none;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-appearance: none;
      height: 48px;
      text-align: center;
      font-size: 0.16rem;
      color: white;
      border-radius: 0.04rem;

      &:disabled {
        background-color: rgba(255, 90, 96, 0.76);
      }
    }
  }
}

.focused-box {
  border-color: #888 !important;
}

.unfocus-box {
  border-color: #e3e3e3 !important;
}

.focused-footer {
  position: relative;
}

.unfocus-footer {
  position: fixed;
}
</style>
